import * as Types from '../types-api.generated';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiWorldModalTabAmountsVariables = Types.Exact<{
  slug: Types.Scalars['String'];
  id: Types.Scalars['Int'];
}>;


export type ApiWorldModalTabAmounts = { allowlistCount: { totalItems: number }, creatorsCount: { totalItems: number }, collectorsCount: { totalItems: number } };



export const ApiWorldModalTabAmountsDocument = /*#__PURE__*/ `
    query WorldModalTabAmounts($slug: String!, $id: Int!) {
  allowlistCount: exhibitionAllowlistV2(slug: $slug) {
    totalItems
  }
  creatorsCount: exhibitionCreators(exhibitionId: $id) {
    totalItems
  }
  collectorsCount: exhibitionCollectorStats(exhibitionId: $id) {
    totalItems
  }
}
    `;

export const useWorldModalTabAmounts = <
      TData = ApiWorldModalTabAmounts,
      TError = ClientError
    >(
      variables: ApiWorldModalTabAmountsVariables,
      options?: Omit<UseQueryOptions<ApiWorldModalTabAmounts, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiWorldModalTabAmounts, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiWorldModalTabAmounts, TError, TData>(
      {
    queryKey: ['WorldModalTabAmounts', variables],
    queryFn: apiFetcher<ApiWorldModalTabAmounts, ApiWorldModalTabAmountsVariables>(ApiWorldModalTabAmountsDocument, variables),
    ...options
  }
    )};

useWorldModalTabAmounts.getKey = (variables: ApiWorldModalTabAmountsVariables) => ['WorldModalTabAmounts', variables];

export const useInfiniteWorldModalTabAmounts = <
      TData = InfiniteData<ApiWorldModalTabAmounts>,
      TError = ClientError
    >(
      variables: ApiWorldModalTabAmountsVariables,
      options: Omit<UseInfiniteQueryOptions<ApiWorldModalTabAmounts, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiWorldModalTabAmounts, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiWorldModalTabAmounts, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['WorldModalTabAmounts.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiWorldModalTabAmounts, ApiWorldModalTabAmountsVariables>(ApiWorldModalTabAmountsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteWorldModalTabAmounts.getKey = (variables: ApiWorldModalTabAmountsVariables) => ['WorldModalTabAmounts.infinite', variables];


useWorldModalTabAmounts.fetcher = (variables: ApiWorldModalTabAmountsVariables, options?: RequestInit['headers']) => apiFetcher<ApiWorldModalTabAmounts, ApiWorldModalTabAmountsVariables>(ApiWorldModalTabAmountsDocument, variables, options);
